/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AuthUserDto } from '../../models/auth-user-dto';

export interface AuthControllerMe$Params {
}

export function authControllerMe(http: HttpClient, rootUrl: string, params?: AuthControllerMe$Params, context?: HttpContext): Observable<StrictHttpResponse<AuthUserDto>> {
  const rb = new RequestBuilder(rootUrl, authControllerMe.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AuthUserDto>;
    })
  );
}

authControllerMe.PATH = '/auth/me';
